import { Modal } from "@mui/material";
import { useModal } from "../../hooks/modalStore";
import SolvingHistoryGrid from "../SolvingHistoryGrid/SolvingHistoryGrid";

export default function ModalProvider({ children }) {
  const { open, children: modalChildren, handleClose } = useModal();
  return (
    <>
      {children}
      <Modal
        open={open}
        onClose={handleClose}
        // sx={{
        //   display: "flex",
        //   alignItems: "center",
        //   justifyContent: "center",
        // }}
      >
        {modalChildren || <></>}
      </Modal>
    </>
  );
}
